import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { formatMoney } from 'accounting-js';

import * as DF from 'fixedassets/components/detail/field';

const dateFormat = (date) =>{
  if (date) {  
    let dateArray1 = date.split("T")
    let dateArray = dateArray1[0].split("-")

    if(dateArray[1] === 'Jan')
      dateArray[1] = '01'
    else if(dateArray[1] === 'Feb')
      dateArray[1] = '02'
    else if(dateArray[1] === 'Mar')
      dateArray[1] = '03'
    else if(dateArray[1] === 'Apr')
      dateArray[1] = '04'
    else if(dateArray[1] === 'May')
      dateArray[1] = '05'
    else if(dateArray[1] === 'Jun')
      dateArray[1] = '06'
    else if(dateArray[1] === 'Jul')
      dateArray[1] = '07'
    else if(dateArray[1] === 'Aug')
      dateArray[1] = '08'
    else if(dateArray[1] === 'Sep')
      dateArray[1] = '09'
    else if(dateArray[1] === 'Oct')
      dateArray[1] = '10'
    else if(dateArray[1] === 'Nov')
      dateArray[1] = '11'
    else if(dateArray[1] === 'Dec')
      dateArray[1] = '12'

    return dateArray[2]+"/"+dateArray[1]+"/"+dateArray[0]
  }
  else
    return null
}

class AssetDetailGeneral extends Component {
  render() {
    let totalImports = 0
    var fechaInicial;
    var fechaFinal;

    if (this.props.asset._bills && this.props.asset._bills.length > 0) { 
      if (this.props.asset._bills[0].billDate !== undefined) 
        fechaInicial = this.props.asset._bills[0].billDate

      else if(this.props.asset._bills[1].billDate !== undefined)
        fechaInicial = this.props.asset._bills[1].billDate

      if (this.props.asset._bills[0].billDate !== undefined) 
        fechaFinal = this.props.asset._bills[0].billDate

      else if(this.props.asset._bills[1].billDate !== undefined)
        fechaFinal = this.props.asset._bills[1].billDate      
      for (const bill in this.props.asset._bills) {
  
        if(this.props.asset._bills[bill].billImport)
          totalImports += this.props.asset._bills[bill].billImport
  
        for (let index = parseInt(bill)+1; index < this.props.asset._bills.length; index++) {
  
          if(this.props.asset._bills[index].billDate){
            if (fechaInicial > this.props.asset._bills[index].billDate ) {
              fechaFinal = fechaInicial
              fechaInicial = this.props.asset._bills[index].billDate
            }
            else if( this.props.asset._bills[index].billDate > fechaFinal)
              fechaFinal = this.props.asset._bills[index].billDate
          }
        }
        
        // if(Date.parse(this.props.asset._bills[parseInt(bill)+1].billDate) < Date.parse(this.props.asset._bills[parseInt(bill)].billDate)){
      }
      
      if (fechaInicial !== undefined) 
        fechaInicial = dateFormat(fechaInicial)
      if(fechaFinal !== undefined)
        fechaFinal = dateFormat(fechaFinal)    
    }
      return (
        <Form.Section title={this.props.t('assets.section.bill')}>

          <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{marginRight: '20px'}}>
              {this.props.asset._bills ? `Total de facturas: ${this.props.asset._bills.length}` :'Total de facturas: 1'}
            </div>
            <div style={{marginRight: '20px'}}>
              {this.props.asset._bills ? `Total importe: ${formatMoney(totalImports/100)}` :`Total importe: ${this.props.asset.billImport ? formatMoney(this.props.asset.billImport): '-'}`}
            </div>
            <div>
              {fechaInicial && fechaFinal ? `Desde ${fechaInicial} al ${fechaFinal}` : ''}
            </div>
          </div>
          <br/>
          
          <div className="row">
            <DF.Text label={'assets.fields.billNumber'} value={this.props.asset.billNumber} />
            <DF.Text label={'assets.fields.billFolio'} value={this.props.asset.billFolio} />
            <DF.Date label={'assets.fields.billDate'} value={this.props.asset.billDate} />
            <DF.Text label={'assets.fields.billConcept'} value={this.props.asset.billConcept} />
            <DF.Text label={'assets.fields.dmsReference'} value={this.props.asset.dmsReference} />
            {this.props.asset.billImport? <DF.Text label={'assets.fields.billImport'} value={formatMoney(this.props.asset.billImport/100)} />:null}
          </div>
        </Form.Section>
      )
  };
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailBill.js